import { useState } from "react";
import type { Product } from "@models/product";
import { PRODUCT_PLACEHOLDER_SRC } from "@utils/productImage";

interface ProductGalleryProps {
    product: Product;
}

export const ProductGallery = ({ product }: ProductGalleryProps) => {
    const images =
        product.images.length > 0
            ? product.images
            : [{ id: "placeholder", url: PRODUCT_PLACEHOLDER_SRC }];
    const [activeIndex, setActiveIndex] = useState(0);
    const active = images[Math.min(activeIndex, images.length - 1)];

    return (
        <div className="flex flex-col gap-3">
            <div className="aspect-square w-full overflow-hidden flex items-center justify-center">
                <img
                    src={active.url}
                    alt={product.name}
                    className="w-full h-full object-contain"
                />
            </div>
            {images.length > 1 && (
                <div
                    role="tablist"
                    aria-label="Product images"
                    className="flex items-center justify-center gap-2"
                >
                    {images.map((image, index) => (
                        <button
                            key={image.id}
                            type="button"
                            role="tab"
                            aria-selected={index === activeIndex}
                            aria-label={`Show image ${index + 1}`}
                            onClick={() => setActiveIndex(index)}
                            className={`h-2 w-2 rounded-full transition-colors ${
                                index === activeIndex
                                    ? "bg-neutral"
                                    : "bg-neutral/30"
                            }`}
                        />
                    ))}
                </div>
            )}
        </div>
    );
};
